import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useReveal } from "@/hooks/useReveal";
import Hero from "./components/Hero";
import QuickOverview from "./components/QuickOverview";
import CastSection from "./components/CastSection";
import ActorSection from "./components/ActorSection";
import RankingSection from "./components/RankingSection";
import GossipSection from "./components/GossipSection";
import BtsSection from "./components/BtsSection";
import CouplesSection from "./components/CouplesSection";
import FaqSection from "./components/FaqSection";
import ReviewsSection from "./components/ReviewsSection";

export default function Home() {
  useReveal();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <QuickOverview />
        <CastSection />
        <ActorSection />
        <RankingSection />
        <GossipSection />
        <BtsSection />
        <CouplesSection />
        <FaqSection />
        <ReviewsSection />
      </main>
      <SiteFooter />
    </div>
  );
}